import styled from 'styled-components'
import { space, width, height, themeGet } from 'styled-system'
import { transitions } from 'polished'

import theme from 'styles/theme'
import { getBGColor, getBtnMainColor } from 'utils/themeUtils'

const baseButtonProps = `
  display: inline-block;
  padding: ${theme.space[2]} ${theme.space[10]};
  box-shadow: 0;

  > * {
    justify-content: center;
  }
`

export const PrimaryWrapper = styled.button`
  ${baseButtonProps}
  background: ${(props) =>
    props.isActive ? getBtnMainColor() : props.theme.colors.backgroundColor};
  border: 1px solid ${getBtnMainColor()};
  color:  ${(props) => (props.isActive ? getBGColor() : getBtnMainColor())}; 
  ${transitions('background ease-in 0.2s', 'color ease-in 0.2s')};
  ${(props) => props.fixedSize && `height: 60px;`}
  ${space}
  ${width}
  ${height}
  
  ${({ ctaStyle }) => ctaStyle}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: ${getBtnMainColor()};
    color: ${getBGColor()};
    border: 1px solid ${getBGColor()};
  }

  &:disabled {
    color: ${themeGet('colors.coallight')};
  }

`

export const SecondaryWrapper = styled.button`
  ${baseButtonProps}
  background: ${(props) =>
    props.isActive
      ? themeGet('colors.alabaster')
      : props.theme.colors.btnMainColor};
  border: 1px solid ${(props) =>
    props.isActive
      ? themeGet('colors.alabaster')
      : props.theme.colors.btnMainColor};
  color: ${theme.colors.white};
  ${transitions('background ease-in 0.2s', 'color ease-in 0.2s')};
  ${(props) => props.fixedSize && `height: 60px;`}
  ${space}
  ${width}
  ${height}

  ${({ ctaStyle }) => ctaStyle}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: ${getBGColor()};
    border-color: ${getBtnMainColor()};
    color: ${getBtnMainColor()};
  }

  &:disabled {
    color: ${themeGet('colors.coallight')};
  }
`

export const TertiaryWrapper = styled.button`
  ${baseButtonProps}
  background: ${(props) => props.theme.colors.buttonColor};
  border: 1px solid ${themeGet('colors.alabaster')};
  color: ${(props) => props.theme.colors.dark};
  ${transitions('background ease-in 0.2s', 'color ease-in 0.2s')};
  ${(props) => props.fixedSize && `height: 60px;`}
  ${space}
  ${width}
  ${height}

  ${({ ctaStyle }) => ctaStyle}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: ${getBtnMainColor()};
    border-color: ${getBtnMainColor()};
    color: ${getBGColor()};
  }

  &:disabled {
    color: ${themeGet('colors.coallight')};
  }
`

export const QuaternaryWrapper = styled.button`
  ${baseButtonProps}
  background: transparent;
  border: 1px solid transparent;
  color: ${getBtnMainColor()};
  text-decoration: underline;
  ${transitions('background ease-in 0.2s', 'color ease-in 0.2s')};
  ${(props) => props.fixedSize && `height: 60px;`}
  ${space}
  ${width}
  ${height}

  ${({ ctaStyle }) => ctaStyle}

  &:disabled {
    color: ${themeGet('colors.coallight')};
  }
`
